import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.833",
      d: "M11 11.917v1.833"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#434343",
      d: "M11 9.167a.917.917 0 1 0 0-1.834.917.917 0 0 0 0 1.834"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.375",
      d: "M11 17.646a6.646 6.646 0 1 0 0-13.292 6.646 6.646 0 0 0 0 13.292"
    }, null, -1)
  ]))]))
}
export default { render: render }